import React from 'react';
import { FileText, Shield, Scale, CheckCircle } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';

const Terms = () => {
  return (
    <div className="dark-container min-h-screen pt-28 pb-20">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <div className="w-20 h-20 mx-auto mb-6 bg-brand-primary/10 border border-brand-primary rounded-sm flex items-center justify-center">
            <Scale className="text-brand-primary" size={36} />
          </div>
          <h1 className="display-large mb-4" style={{ color: 'var(--text-primary)' }}>Terms of Service</h1>
          <p className="body-medium" style={{ color: 'var(--text-muted)' }}>Last Updated: December 2025</p>
        </div>

        <Card className="bg-white/5 border border-white/25 backdrop-blur-xl mb-8">
          <CardContent className="p-8">
            <h2 className="heading-1 mb-4" style={{ color: 'var(--text-primary)' }}>1. Acceptance of Terms</h2>
            <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>
              By accessing or using MatrixLaunch platform, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>
            
            <h2 className="heading-1 mb-4 mt-8" style={{ color: 'var(--text-primary)' }}>2. Eligibility</h2>
            <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>
              You must be at least 18 years old and legally capable of entering into binding contracts. You must not be located in a jurisdiction where crypto token purchases are prohibited.
            </p>
            
            <h2 className="heading-1 mb-4 mt-8" style={{ color: 'var(--text-primary)' }}>3. Platform Services</h2>
            <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>
              MatrixLaunch provides a decentralized platform for token launches. We facilitate connections between projects and investors but do not guarantee investment returns or project success.
            </p>
            
            <h2 className="heading-1 mb-4 mt-8" style={{ color: 'var(--text-primary)' }}>4. Investment Risks</h2>
            <ul className="space-y-2" style={{ color: 'var(--text-secondary)' }}>
              <li>• Cryptocurrency investments carry high risk and potential for total loss</li>
              <li>• Token values are volatile and may fluctuate significantly</li>
              <li>• Projects may fail despite our vetting process</li>
              <li>• No investment advice is provided on this platform</li>
            </ul>
            
            <h2 className="heading-1 mb-4 mt-8" style={{ color: 'var(--text-primary)' }}>5. User Obligations</h2>
            <p className="mb-2" style={{ color: 'var(--text-secondary)' }}>You agree to:</p>
            <ul className="space-y-2" style={{ color: 'var(--text-secondary)' }}>
              <li>• Provide accurate KYC information</li>
              <li>• Comply with applicable laws and regulations</li>
              <li>• Not engage in market manipulation or fraudulent activities</li>
              <li>• Maintain security of your account credentials</li>
            </ul>
            
            <h2 className="heading-1 mb-4 mt-8" style={{ color: 'var(--text-primary)' }}>6. Fees and Payments</h2>
            <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>
              Platform fees are 2% on successful token purchases. All fees are non-refundable except in cases of technical errors on our part.
            </p>
            
            <h2 className="heading-1 mb-4 mt-8" style={{ color: 'var(--text-primary)' }}>7. Limitation of Liability</h2>
            <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>
              MatrixLaunch is not liable for losses arising from token investments, smart contract failures, market conditions, or unauthorized access to your account.
            </p>
            
            <h2 className="heading-1 mb-4 mt-8" style={{ color: 'var(--text-primary)' }}>8. Termination</h2>
            <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>
              We reserve the right to suspend or terminate accounts that violate these terms or engage in suspicious activities.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Terms;
